/**
 * Utility to detect AbortErrors from navigation-based request cancellation.
 * These errors are expected behavior and should be filtered out from error reporting.
 */

interface ErrorLike {
  message?: string
  name?: string
  data?: { message?: string; name?: string }
}

export function isAbortError(error: unknown): boolean {
  if (!error) {
    return false
  }

  const err = error as ErrorLike

  // Get error message from various possible locations
  const errorMessage = err.message || err.data?.message || ''
  const errorName = err.name || err.data?.name || ''

  return (
    errorName === 'AbortError' ||
    errorMessage.includes('AbortError') ||
    errorMessage.includes('aborted') ||
    errorMessage.includes('Fetch is aborted') ||
    errorMessage.includes('The operation was aborted') ||
    errorMessage.includes('The user aborted a request')
  )
}

/**
 * Utility to detect AbortErrors from XState machine events.
 * Machine events have a different structure with nested data.
 */
export function isAbortErrorFromEvent(event: unknown): boolean {
  if (!event) {
    return false
  }

  const evt = event as { data?: unknown }
  return isAbortError(event) || isAbortError(evt.data)
}
